module.exports = __webpack_public_path__ + "img/img05.017850e1.jpg";